import React, { useState, useContext } from "react";
import { Formik, Form, Field } from "formik";
import { businessLogin } from "../../data/Login/business";
import { useHistory } from "react-router-dom";
import { LoginSchema } from "../../schemas/Login/business";
import { GlobalContext } from "../../providers/global";
import ErrorField from "../../components/Layout/Shared/ErrorField";
import { goToAppForBusiness } from "../../helpers/history";

const BusinessForm = () => {
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();

  const initialValues = {
    email: "",
    password: ""
  };
  const globalContext = useContext(GlobalContext);

  const onSubmit = async (values, { setSubmitting }) => {
    const { success, data, error } = await businessLogin(values);
    if (success) {
      globalContext.login(data);
      goToAppForBusiness(history, data.user);
    } else {
      setError(error);
    }
    setSubmitting(false);
  };

  return (
    <div className="col-12">
      <Formik
        initialValues={initialValues}
        validationSchema={LoginSchema}
        onSubmit={onSubmit}
      >
        {({ errors }) => (
          <Form>
            <div className="form-group">
              <Field
                type="email"
                className="custom-input"
                placeholder="Business Email Address"
                name="email"
              />
              <ErrorField message={errors.email} />
            </div>
            <div className="form-group" style={{ position: "relative" }}>
              <Field
                type={showPassword ? "text" : "password"}
                className="custom-input"
                placeholder="Password"
                name="password"
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </span>
              <ErrorField message={errors.password} />
            </div>
            {error && <ErrorField message={error} />}
            <button type="submit" className="btn btn-blue-gradient">
              SIGN IN
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BusinessForm;
